import { z } from 'zod';

export const PackingPriorityEnum = z.enum([
  'efficiency',
  'by_area',
  'keep_areas_together',
  'group_by_phase',
]);

export const TruckTypeEnum = z.enum(['24_box', '53_trailer']);

export const PackTrucksRequestSchema = z.object({
  truckType: TruckTypeEnum.default('24_box'),
  maxStack: z.number().int().min(1).max(5).default(2),
  padding: z.number().min(0).max(12).default(2),
  priority: PackingPriorityEnum.default('efficiency'),
});

export const SaveTruckConfigSchema = z.object({
  name: z.string().min(1, 'Config name is required'),
  config: z.string(),
  trucksData: z.string(),
  costPerTruck: z.number().default(0),
  importCost: z.number().default(0),
  tariffCost: z.number().default(0),
});

export type PackTrucksRequest = z.infer<typeof PackTrucksRequestSchema>;
export type SaveTruckConfig = z.infer<typeof SaveTruckConfigSchema>;
